import { Pipe, PipeTransform } from "@angular/core";
import { SeparateurMillier } from './SeparateurMillier';

@Pipe({
  name:'separeteurMil'
})
export class SepareurPipeService  implements PipeTransform {

  // transform(value: SeparateurMillier):string {
  //   if (value==null) return null
  //  return this.separateurMil(value)
  // }
  transform(value: number):string {
    if (value===0 ||value===NaN) return '0 XAF'
   return this.separateurMil(value)
  }
  
  
  separateurMil(value) {
    var nombre = '' + value;
    var retour = '';
    var count = 0;

    for (var i = nombre.length - 1; i >= 0; i--) {
        if (count != 0 && count % 3 == 0)
            retour = nombre[i] + ' ' + retour;
        else retour = nombre[i] + retour; count++;
    }
    //alert('nb : ' + nbr + ' => ' + retour);
    return `${retour} XAF`;
}
}